import {
  isQuotingToolAvailable,
  hasProcessPermission,
} from 'modules/common/permissions';

import { initAddOnDetailsPage } from './detailsPage/data/sagas';
import AddOnDetailsPage from './detailsPage/entry';
import { initAddOnsListPage } from './listPage/data/sagas';
import AddOnsListPage from './listPage/entry';

export default [
  {
    component: AddOnsListPage,
    exact: true,
    name: 'addOnsListPage',
    helpId: 'add_on_list',
    path: '/processes/add_ons',
    permissions: [isQuotingToolAvailable, hasProcessPermission],
    saga: initAddOnsListPage,
  },
  {
    component: AddOnDetailsPage,
    exact: true,
    name: 'addOnDetailsPage',
    helpId: 'add_on_details',
    path: '/processes/add_ons/:addOnId',
    permissions: [isQuotingToolAvailable, hasProcessPermission],
    saga: initAddOnDetailsPage,
  },
];
